

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.icfaDetailsTitle} - Nos offres d'alternances`,
            // meta: this.campusInfo?.attributes?.metaOffreAlt != null && this.campusInfo?.attributes?.metaOffreAlt != undefined ?
            //     JSON.parse(this.campusInfo?.attributes?.metaOffreAlt?.replace('\n', '')) : null
        };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri
        let diplomaSelectBox = '';

        if (this.$route.query?.diploma) {
            diplomaSelectBox = this.$route.query?.diploma;
        }

        return {
            strapiBaseUri, diplomaSelectBox
        }
    },
    async mounted() {

        if (this.loading == true) {
            let offreAltDiplomaSortedArray = [];
            for (const instance of this.instances) {
                let offreAlternances = await this.$http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes?.prefix}-offre-alternances?populate[imageOfferAlternance][fields][0]=url&populate[diplome][fields][0]=nomCourt&populate[diplome][fields][0]=couleurFormationRGB&pagination[pageSize]=100`);

                offreAlternances = offreAlternances.data;
                for (const offreAlternance of offreAlternances) {
                    offreAlternance.instance = instance.attributes.subFolderName;
                }

                offreAlternances = offreAlternances.filter(offreAlternance => {
                    return offreAlternance.attributes.diplome.data
                });
                offreAltDiplomaSortedArray = offreAltDiplomaSortedArray.concat(offreAlternances);


            };

            this.offreAlternancesTous = offreAltDiplomaSortedArray;
            this.offreAlternances = offreAltDiplomaSortedArray;

            this.diplomasList = []
            offreAltDiplomaSortedArray.map((offre) => {

                if (this.diplomasList.findIndex(diploma => diploma?.id == offre.attributes.diplome?.data?.id) == -1
                    && offre.attributes.diplome?.data?.id != undefined) {
                    this.diplomasList.push(offre.attributes.diplome.data);
                }

            });

            this.loading = false;
        }

        this.clickDiplome();
    },
    methods: {
        styleDiplomaButonGrad(offreAlternance) {
            let r, g, b;
            r = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(0, 3);
            g = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(3, 6);
            b = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(6, 9);

            return {
                '--text-color': '#aaaaaa',
                '--text-color1r': Number(r) + 10,
                '--text-color1g': Number(g) - 55,
                '--text-color1b': Number(b) + 30,
                '--text-color2r': Number(r) + 10,
                '--text-color2g': Number(g) + 10,
                '--text-color2b': Number(b) + 25,
                '--text-color3r': Number(r) + 40,
                '--text-color3g': Number(g) - 50,
                '--text-color3b': Number(b) - 50,
                '--text-color4r': Number(r) - 30,
                '--text-color4g': Number(g) + 30,
                '--text-color4b': Number(b) + 55
            }
        },
        clickDiplome() {
            this.offreAlternancesTous = [];
            if (this.diplomaSelectBox != '') {
                this.offreAlternances.map(offre => {
                    if (offre.attributes.diplome.data.id == this.diplomaSelectBox) {
                        this.offreAlternancesTous.push(offre);
                    }
                })
            } else {
                this.offreAlternancesTous = this.offreAlternances;
            }
        }
    },


    async asyncData({ params, $http, store, redirect }) {
        let instances = store.state.instances;
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));
        let offreAlternances = [];
        let offreAlternancesTous = [];
        let diplomasList = [];
        let campusDiplomas = [];
        let campusDiplomasTous = [];
        let collone1Diplomas = [];
        let collone2Diplomas = [];
        let collone3Diplomas = [];
        let loading = true;

        for (const instance of instances) {
            if (process.server) {
                offreAlternances = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes?.prefix}-offre-alternances?populate=imageOfferAlternance,diplome&pagination[pageSize]=100`);

                offreAlternances = offreAlternances.data;
                offreAlternancesTous = offreAlternancesTous.concat(offreAlternances);
            }

            campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas`);
            campusDiplomas = campusDiplomas.data;

            collone1Diplomas = campusDiplomas.filter((diploma) => {
                return diploma.attributes.collone === 'Collone_1';
            })
            collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
                return d1.attributes.ordre - d2.attributes.ordre
            })
            collone2Diplomas = campusDiplomas.filter((diploma) => {
                return diploma.attributes.collone === 'Collone_2';
            })
            collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
                return d1.attributes.ordre - d2.attributes.ordre
            })
            collone3Diplomas = campusDiplomas.filter((diploma) => {
                return diploma.attributes.collone === 'Collone_3';
            })
            collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
                return d1.attributes.ordre - d2.attributes.ordre
            })
            campusDiplomasTous = campusDiplomasTous.concat(collone1Diplomas, collone2Diplomas, collone3Diplomas);
        }



        return {
            instances, offreAlternances, offreAlternancesTous, diplomasList, loading,
            campusDiplomas, campusDiplomasTous, collone1Diplomas, collone2Diplomas, collone3Diplomas, infoGenerales
        }
    },

}
